import classnames from "classnames";

type TSpinnerChaseProps = {
  className?: string;
};

const SpinnerChase = ({ className }: TSpinnerChaseProps) => {
  return <div className={classnames('spinner-chase', className)}>
    <div className="chase-dot" />
    <div className="chase-dot" />
    <div className="chase-dot" />
    <div className="chase-dot" />
    <div className="chase-dot" />
    <div className="chase-dot" />
  </div>;
};

export default SpinnerChase;
